const preloadedFonts = ['AkkuratLL'];

export const preloadFont = (family: string, document: Document) => {
  if (preloadedFonts.includes(family)) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = `https://fonts.googleapis.com/css?family=${family}&display=swap`;
  link.setAttribute('as', 'style');
  link.crossOrigin = '';
  document.head.appendChild(link);
  preloadedFonts.push(family);
};
